@for (file of getFilesById(); track $index) {
  <app-file-card
    [fileCard]="{
      id: file.id,
      fileParams: file.file,
      fileType: 'TECHNICAL_CONCLUSION',
      isEditModeActive: isEditModeActive(),
      shouldCheckImageType: false
    }"
    (handleDelete)="handleDelete($event, file)"
  />
}
<app-file-upload-card
  [fileUploadParams]="{
    parentId: technicalConclusionId(),
    recordId: technicalConclusionId(),
    type: `TECHNICAL_CONCLUSION-${technicalConclusionId()}`,
    entityFileType: 'TECHNICAL_CONCLUSION'
  }"
  [isEditModeActive]="isEditModeActive()"
  (attachFile)="attachFile($event)"
/>
